<h1 class="contact-support__header" i18n="@@S_LIVE_MAP_DHC_CONTACT_SUPPORT_TITLE">Contact Support</h1>
<p class="contact-support__description" i18n="@@S_LIVE_MAP_DHC_CONTACT_SUPPORT_SUBTITLE">
  If you are still having an issue with your tracker we're here to help you.
</p>
<button
  *ngIf="(chatLoading$ | async) === false"
  mat-flat-button
  color="accent"
  a7s-id="device-health-check_chat-with-us-button"
  class="contact-support__buttons__chat-with-us btn-uppercase"
  i18n="@@S_LIVE_MAP_DHC_CHAT_WITH_US_BUTTON"
  (click)="openLiveChat()"
>
  CHAT WITH US
</button>
<button
  *ngIf="(chatLoading$ | async) === true"
  mat-flat-button
  color="accent"
  disabled
  class="contact-support__buttons__chat-with-us contact-support__buttons__chat-with-us__loading"
>
  <mat-spinner class="contact-support__buttons__chat-with-us__loading__spinner" color="accent" [diameter]="24"></mat-spinner>
</button>
